import { useCallback, useState } from 'react';
import {
  getDefaultSchemaGitSettings,
  loadSchemaGitSettings,
  saveSchemaGitSettings,
  type SchemaGitSettings,
} from '../storage/schemaGitSettings';

export function useSchemaGitSettings() {
  const [settings, setSettings] = useState<SchemaGitSettings>(() => loadSchemaGitSettings());
  const [draft, setDraft] = useState<SchemaGitSettings>(() => loadSchemaGitSettings());

  const applyDraft = useCallback((): SchemaGitSettings | null => {
    const next: SchemaGitSettings = {
      repoUrl: draft.repoUrl.trim(),
      branch: draft.branch.trim() || 'master',
    };
    if (!next.repoUrl) {
      return null;
    }
    saveSchemaGitSettings(next);
    setSettings(next);
    setDraft(next);
    return next;
  }, [draft]);

  const resetDraftToActive = useCallback(() => {
    setDraft(settings);
  }, [settings]);

  const resetDraftToEnvDefaults = useCallback(() => {
    setDraft(getDefaultSchemaGitSettings());
  }, []);

  const connectionChanged =
    draft.repoUrl.trim() !== settings.repoUrl || draft.branch.trim() !== settings.branch;

  return {
    settings,
    draft,
    setDraft,
    applyDraft,
    resetDraftToActive,
    resetDraftToEnvDefaults,
    connectionChanged,
  };
}
